{
  "supported_languages": ["en", "nl", "pt", "de", "fr"],
  "ui_languages": {
    "en": {
      "code": "en",
      "description": "english",
      "lang_code": "en",
      "culture_code": "en-US",
      "flag": "/icons/us.svg"
    },
    "en-UK": {
      "code": "en-UK",
      "description": "english (UK)",
      "lang_code": "en-UK",
      "culture_code": "en-UK",
      "flag": "/icons/uk.svg",
      "hidden": true
    },
    "nl-NL": {
      "code": "nl-NL",
      "description": "dutch",
      "lang_code": "nl-NL",
      "culture_code": "nl-NL",
      "flag": "/icons/nl.svg"
    },
    "pt-BR": {
      "code": "pt-BR",
      "description": "português",
      "lang_code": "pt-BR",
      "culture_code": "pt-BR",
      "flag": "/icons/br.svg"
    },
    "de-DE": {
      "code": "de-DE",
      "description": "deutsch",
      "lang_code": "de-DE",
      "culture_code": "de-DE",
      "flag": "/icons/de.svg"
    },
    "fr-FR": {
      "code": "fr-FR",
      "description": "français",
      "lang_code": "fr-FR",
      "culture_code": "fr-FR",
      "flag": "/icons/fr.svg"
    }
  },
  "quotation_languages": {
    "en": {
      "description": "english",
      "lang_code": "en",
      "flag": "/icons/us.svg"
    },
    "nl-NL": {
      "description": "dutch",
      "lang_code": "nl",
      "flag": "/icons/nl.svg"
    },
    "pt-BR": {
      "description": "português",
      "lang_code": "pt",
      "flag": "/icons/br.svg"
    },
    "de-DE": {
      "description": "deutsch",
      "lang_code": "de",
      "flag": "/icons/de.svg"
    },
    "fr-FR": {
      "description": "français",
      "lang_code": "fr",
      "flag": "/icons/fr.svg"
    }
  }
}
